import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 80"
    >
      <text
        x="2"
        y="64"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="900"
        fontSize="66"
        fill="currentColor"
        letterSpacing="-2"
      >
        N
      </text>
      <circle cx="48" cy="12" r="5" fill="#4da6ff" />
    </svg>
  );
};
